<template>
  <div class="remove_table_shadow">
    <div class="row">
      <!--<div class="col-sm-12 col-md-6">
         <app-breadcrumb
          :page-title="$t('services')"
          :directory="$t('datatables')"
          :icon="'grid'"
        /> 
      </div>-->
      <div class="col-sm-12 col-md-12 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openAddEditModal"
          >
            {{ $t("add") }}
          </button>
        </div>
      </div>
    </div>

    <app-table :id="tableId" :options="options" @action="getListAction" />

    <company-services-addmodal
      v-if="isAddEditModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
    />

    <app-delete-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="demo-delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />
  </div>
</template>

<script>
import CoreLibrary from "../../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../../Config/ApiUrl";
import { TableHelpers } from "../../../Demo/Tables/mixins/TableHelpers";

export default {
  extends: CoreLibrary,
  name: "DatatableWithFilter",
  mixins: [TableHelpers],
  data() {
    return {
      deleteLoader: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      selectedUrl: "",
      tableId: "demo-crud-table",
      rowData: {},
      options: {
        url: actions.SERVICE_LIST,
        name: this.$t("demo_crud"),
        datatableWrapper: false,
        showHeader: true,
        columns: [
          {
            title: this.$t("name"),
            type: "custom-html",
            key: "name",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },

        ],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "none",
            component: "app-confirmation-modal",
            modalId: "demo-delete",
          },
        ],
        showFilter: false,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
  },
  methods: {
   
    openAddEditModal() {
      this.isAddEditModalActive = true;

    },
    
    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      this.reSetData();
    },

    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == "Delete") {
        this.openDeleteModal();
      } else if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `${actions.SERVICE_SHOW}/${rowData.id}`;
        this.openAddEditModal();
      } 
    },
    
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    confirmed() {
      let url = `${actions.SERVICE_DELETE}/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#demo-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(response.data.message);
        })
        .catch(({ error }) => {
          //trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    /**
     * cancelled $emit Form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
  },
  mounted() {

    // var user_id = this.$store.state.userCompanyProfile.dataProfile.id;
    // if (user_id != null) {
    //   this.options.url = actions.MYDOCUMENT_LIST+'?user_id=' + user_id
    // }
    setTimeout(() => {
      $( ".remove_table_shadow .datatable .table-responsive " ).removeClass("shadow");
    }, 1000);
  }
};
</script>

<style>
.remove_table_shadow .datatable .table-responsive {
  box-shadow: none !important;
}
</style>